module.exports = fox._r("fonts/mc-icons-webfont.eot", __webpack_public_path__ + "_/_/_/common/frame/fonts/2z70KI4.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/mc-icons-webfont.eot
// module id = 143
// module chunks = 2